export class ColumnList {
    buyBackName: boolean;
    startDate: boolean;
    pricePerShare: boolean;
    buyBackAmountActual: boolean;
    postBuybackConsolidation: boolean;
    className: boolean;
    state: boolean;
}